module.exports = "img/flags/AE.4ff42ac.png";